var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoProfileImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.582 61.25c0-11.276 9.14-20.416 20.417-20.416 11.276 0 20.416 9.14 20.416 20.416",
    stroke: "url(#a)",
    strokeWidth: 4.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.003 32.084c6.443 0 11.666-5.224 11.666-11.667S41.446 8.75 35.003 8.75s-11.667 5.224-11.667 11.667 5.223 11.667 11.667 11.667",
    stroke: "url(#b)",
    strokeWidth: 4.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 23.326,
    y1: 32.084,
    x2: 47.407,
    y2: 54.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577,
    stopColor: "#EBBFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6EC85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 28.333,
    y1: -1.25,
    x2: 49.428,
    y2: 8.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577,
    stopColor: "#EBBFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6EC85"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProfileImage);
export default __webpack_public_path__ + "static/media/no-profile-image.3986858e8c5382ee53793832c924894e.svg";
export { ForwardRef as ReactComponent };